import { render, staticRenderFns } from "./ChannelGroupView.vue?vue&type=template&id=02414712&"
import script from "./ChannelGroupView.vue?vue&type=script&lang=js&"
export * from "./ChannelGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelGroupView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports